<template>
    <div class="box coming-soon-add-on">
        <div class="box-content">
            <div class="add-on-header">
                More exciting podcasting tools coming soon...
            </div>

            <p v-if="!user.beta_participant">
                Want early access to new podcasting tools? <a href="/api/user/beta/?beta=1" @click="handleBecomeBetaParticipant">Click here</a> to join our Beta Tools Program.
            </p>
        </div>
    </div>
</template>
<script>
import apiCall from '@/utils/apiCall';
import toasts from '@/mixins/toasts';
import { mapMutations, mapState } from 'vuex';

export default {
    mixins: [toasts],

    computed: {
        ...mapState(['user']),
    },

    methods: {
        ...mapMutations(['setUser']),

        /**
         * Handles becoming beta participant.
         *
         * @param {Event} event Click event.
         */
        async handleBecomeBetaParticipant(event) {
            event.preventDefault();

            const response = await apiCall(this, 'put', event.target.href);
            const { status, data } = response;

            if (200 === status) {
                this.setUser(data);
                this.toastSuccess({
                    message: {
                        title: 'Joined Beta Tools Program successfully!',
                    },
                });
            } else {
                this.toastError({
                    message: {
                        title: 'An error occurred while joining Beta Tools Program.',
                    },
                });
            }
        },
    },
};
</script>
